import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const WarningIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.75 7.75C10.75 7.33578 10.4142 7 10 7C9.58579 7 9.25001 7.33578 9.25001 7.75L9.25001 11C9.25001 11.4142 9.58579 11.75 10 11.75C10.4142 11.75 10.75 11.4142 10.75 11L10.75 7.75Z"
          fill={color}
        />
        <path
          d="M9.25001 14.25C9.25001 13.8358 9.58579 13.5 10 13.5C10.4142 13.5 10.75 13.8358 10.75 14.25C10.75 14.6642 10.4142 15 10 15C9.58579 15 9.25001 14.6642 9.25001 14.25Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9236 2.61936C11.0551 1.12499 8.89586 1.12735 8.03059 2.62363L0.80242 15.1229C-0.0650064 16.6229 1.01743 18.4993 2.75019 18.4993H17.2432C18.9782 18.4993 20.0603 16.6187 19.1885 15.1187L11.9236 2.61936ZM9.3291 3.37454C9.61752 2.87579 10.3373 2.87499 10.6268 3.37312L17.8916 15.8724C18.1823 16.3724 17.8215 16.9993 17.2432 16.9993H2.75019C2.17261 16.9993 1.81179 16.3739 2.10093 15.8739L9.3291 3.37454Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
